import { type User } from '../models/User'
import { getIntegrationDisplayName, getIntegrationServiceIdsForCategory, IntegrationCategory, type IntegrationServiceId } from './integrations'

const documentServiceIds = getIntegrationServiceIdsForCategory(IntegrationCategory.DOCUMENT)

export const getConnectedDocumentServiceIds = (currentUser?: User | null): IntegrationServiceId[] =>
  currentUser?.integrations?.filter((i) => documentServiceIds.includes(i.serviceId as IntegrationServiceId)).map((i) => i.serviceId as IntegrationServiceId) ??
  []

export const sortDocumentServiceIdsByDisplayName = (serviceIds: IntegrationServiceId[]): IntegrationServiceId[] =>
  [...serviceIds].sort((a, b) => getIntegrationDisplayName(a).localeCompare(getIntegrationDisplayName(b)))
